import React from "react";
import { UseFormRegisterReturn } from "react-hook-form";
import MONTH_SELECT_OPTIONS from "constants/monthSelectOptions";

interface MonthSelectFieldProps {
    register: UseFormRegisterReturn;
    value?: string;
    error?: string;
    disabled?: boolean;
    id?: string;
    onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}

/**
 * Month select field component
 */
const MonthSelectField = ({ register, value, error, disabled, id, onChange }: MonthSelectFieldProps) => {
    return (
        <div className="form-control flex-1 min-w-0">
            <label className="label h-6" htmlFor={id}>
                <span className="text-base-content text-xs font-bold leading-4">Month</span>
            </label>
            <select
                {...register}
                onChange={onChange}
                className={`select select-bordered bg-base-100 w-full h-9 text-sm min-h-9 ${
                    disabled ? "opacity-50 cursor-not-allowed" : ""
                } ${error ? "select-error" : ""} ${!value ? "text-gray-400" : ""}`}
                disabled={disabled}
                value={value || ""}
                id={id}
            >
                <option value="" disabled>
                    Select
                </option>
                {MONTH_SELECT_OPTIONS.map((month) => (
                    <option key={month.value} value={month.value} className="text-base-content">
                        {month.label}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default MonthSelectField;
